import { render, staticRenderFns } from "./CataloguingLifecycleDisplayWidget.vue?vue&type=template&id=fcd63e8c&scoped=true"
import script from "./CataloguingLifecycleDisplayWidget.vue?vue&type=script&lang=js"
export * from "./CataloguingLifecycleDisplayWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd63e8c",
  null
  
)

export default component.exports